import { render, staticRenderFns } from "./RegisterItem.vue?vue&type=template&id=fc83eece&scoped=true"
import script from "./RegisterItem.vue?vue&type=script&lang=js"
export * from "./RegisterItem.vue?vue&type=script&lang=js"
import style0 from "./RegisterItem.vue?vue&type=style&index=0&id=fc83eece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc83eece",
  null
  
)

export default component.exports